import * as React from 'react';
import * as styles from '../support.module.scss';
import { FormGroup, FormControlLabel, Checkbox, TextField } from '@material-ui/core';
import FilterType from '../../../models/enums/filterType';
import FilterDatePicker from './filter-date-picker';
import { SupportContext } from '../../../shared/support-context';
import useSupport from '../../../hooks/useSupport';
import Filter from './filter';

interface Props {
  filterType: string;
  localFilters?: string[];
  filters?: string[];
}

/**
 * FilterSection
 * @function FilterSection - Individual section for filters
 */
const FilterSection = ({ filterType, filters, localFilters }: Props) => {
  const { updateLocalFilters } = useSupport();
  const { localSelectedFilters } = React.useContext(SupportContext);

  const [allChecked, setAllChecked] = React.useState<boolean>(false);

  //Removes "All" check if one of the filters is unchecked
  React.useEffect(() => {
    if (localFilters && filters && localFilters.length !== filters.length && allChecked) {
      setAllChecked(false);
    }
  }, [localFilters]);

  /**
   *
   * @param date Moment date object
   * @param isStartDate Boolean indicating whether the value is a start date or not
   */
  const handleDateChange = (date: any, isStartDate: boolean) => {
    if (date && date.isValid) {
      return updateLocalFilters(filterType, date, null, isStartDate);
    }
    updateLocalFilters(filterType, null, null, isStartDate);
  };

  /**
   * @function chooseFilters - Displays either date pickers or checkboxes based on FilterType
   */
  const chooseFilters = () => {
    if (filterType === FilterType.CreatedDate) {
      return (
        <React.Fragment>
          <FilterDatePicker
            label="Start Date"
            date={localSelectedFilters.createdDateStart}
            isStartDate={true}
            changeDate={(date: string | null, isStartDate: boolean) => handleDateChange(date, isStartDate)}
          />
          <FilterDatePicker
            label="End Date"
            date={localSelectedFilters.createdDateEnd}
            isStartDate={false}
            changeDate={(date: string | null, isStartDate: boolean) => handleDateChange(date, isStartDate)}
          />
        </React.Fragment>
      );
    }
    return (
      <FormGroup row classes={{ root: styles.checkboxForm }}>
        {filters.length > 0 ? (
          <React.Fragment>
            <FormControlLabel
              key={`filter-all`}
              classes={{ root: styles.checked }}
              control={
                <Filter filterType={filterType} allChecked={allChecked} setAllChecked={check => setAllChecked(check)} />
              }
              label="All"
            />
            {filters.map((filter, index) => {
              return (
                <FormControlLabel
                  key={`filter-${index}`}
                  classes={{ root: styles.checked }}
                  control={<Filter label={typeof filter === 'string' ? filter : filter.text} filterType={filterType} />}
                  label={typeof filter === 'string' ? filter : filter.text}
                />
              );
            })}
          </React.Fragment>
        ) : (
          <span className={styles.checked}>No filters available</span>
        )}
      </FormGroup>
    );
  };

  return (
    <div className={styles.filterSection}>
      <span className={styles.title}>{filterType}</span>
      {chooseFilters()}
    </div>
  );
};

export default FilterSection;
